var _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M443.92,319.263H263.174c-3.232,0-5.862-2.63-5.862-5.862V50.127 c0-3.232,2.63-5.862,5.862-5.862H443.92c3.232,0,5.862,2.629,5.862,5.862v263.273 C449.783,316.633,447.153,319.263,443.92,319.263z M263.174,44.515c-3.095,0-5.612,2.518-5.612,5.612v263.273 c0,3.095,2.518,5.612,5.612,5.612H443.92c3.095,0,5.612-2.517,5.612-5.612V50.127c0-3.094-2.518-5.612-5.612-5.612H263.174z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M235.493,319.263H54.746c-3.232,0-5.862-2.63-5.862-5.862V50.127 c0-3.232,2.629-5.862,5.862-5.862h180.747c3.232,0,5.862,2.629,5.862,5.862v263.273 C241.355,316.633,238.725,319.263,235.493,319.263z M54.746,44.515c-3.094,0-5.612,2.518-5.612,5.612v263.273 c0,3.095,2.518,5.612,5.612,5.612h180.747c3.095,0,5.612-2.517,5.612-5.612V50.127c0-3.094-2.518-5.612-5.612-5.612H54.746z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 380.332,
    style: {
      fill: "#E0E0E0"
    },
    width: 500,
    height: 0.25
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 51.672,
    y: 394.597,
    style: {
      fill: "#E0E0E0"
    },
    width: 16.06,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.352,
    y: 391.887,
    style: {
      fill: "#E0E0E0"
    },
    width: 53.53,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.732,
    y: 403.887,
    style: {
      fill: "#E0E0E0"
    },
    width: 36.25,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.352,
    y: 391.757,
    style: {
      fill: "#E0E0E0"
    },
    width: 43.19,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.452,
    y: 391.757,
    style: {
      fill: "#E0E0E0"
    },
    width: 6.33,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.212,
    y: 397.987,
    style: {
      fill: "#E0E0E0"
    },
    width: 53.89,
    height: 0.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 77.312,
    y: 57.889,
    style: {
      fill: "#E6E6E6"
    },
    width: 64.777,
    height: 122.118
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.819,
    y: 57.889,
    style: {
      fill: "#F0F0F0"
    },
    width: 76.09,
    height: 122.118
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.384,
    y: 68.736,
    style: {
      fill: "#FFFFFF"
    },
    width: 52.924,
    height: 100.424
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M98.435,91.991c-2.663,3.394-4.756,7.137-6.16,11.223c-1.411,4.106-2.323,8.721-1.634,13.054 c0.588,3.694,2.78,7.272,6.326,8.755c3.812,1.595,7.814,0.073,10.873-2.365c2.837-2.26,6.504-6.206,5.553-10.168 c-0.991-4.131-5.924-4.948-9.327-3.562c-7.815,3.183-11.522,12.16-12.116,20.018c-0.629,8.31,0.72,22.008,10.987,23.855 c1.888,0.34,2.698-2.551,0.798-2.893c-7.323-1.317-8.59-10.26-8.848-16.343c-0.287-6.768,1.096-14.016,6.093-18.946 c1.946-1.92,5.453-4.562,8.274-2.917c3.262,1.903-0.472,5.995-2.162,7.631c-2.15,2.08-5.216,4.023-8.327,3.157 c-2.928-0.815-4.639-3.756-5.154-6.579c-0.703-3.85,0.258-8.053,1.489-11.7c1.228-3.636,3.088-7.079,5.458-10.1 C101.735,92.61,99.626,90.472,98.435,91.991L98.435,91.991z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 378.494,
    y: 68.776,
    style: {
      fill: "#E6E6E6"
    },
    width: 55.273,
    height: 70.916
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.128,
    y: 68.776,
    style: {
      fill: "#F0F0F0"
    },
    width: 64.927,
    height: 70.916
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.114,
    y: 75.075,
    style: {
      fill: "#FFFFFF"
    },
    width: 52.672,
    height: 58.318
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.416,
    y: 93.709,
    style: {
      fill: "#F0F0F0"
    },
    width: 19.013,
    height: 21.051
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 378.494,
    y: 167.679,
    style: {
      fill: "#E6E6E6"
    },
    width: 55.273,
    height: 70.916
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.128,
    y: 167.679,
    style: {
      fill: "#F0F0F0"
    },
    width: 64.927,
    height: 70.916
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.114,
    y: 173.978,
    style: {
      fill: "#FFFFFF"
    },
    width: 52.672,
    height: 58.318
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.416,
    y: 192.611,
    style: {
      fill: "#F0F0F0"
    },
    width: 19.013,
    height: 21.051
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48.884,
    y: 305.486,
    style: {
      fill: "#EBEBEB"
    },
    width: 132.323,
    height: 62.147
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "59.702,364.694 48.884,464.128 55.846,464.128 76.671,364.852  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "173.427,364.694 184.245,464.128 177.283,464.128 156.459,364.852  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "82.299,288.235 88.107,305.486 77.372,305.486  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "62.044,305.486 82.299,305.486 88.107,277.313 67.866,277.313  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "80.176,302.789 84.876,280.01 69.975,280.01 65.275,302.789  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M119.133,287.004c-2.138-5.185-1.946-11.039,0.527-16.073c4.242-7.905,5.48-9.855,2.635-11.488 c-2.846-1.634-3.926,6.376-3.926,6.376c-1.349-3.617-1.487-7.574-0.395-11.277c1.871-5.77,3.057-15.177,0.474-16.178 s-0.474,11.725-2.635,16.073c-1.134-3.054-1.869-6.243-2.187-9.485c-0.29-4.637,0.184-12.015-1.845-13.912 c-2.029-1.897-3.32-0.606-1.344,9.617c1.197,6.078,1.858,12.25,1.976,18.444c0,0-4.4-13.412-7.352-13.807 c-2.951-0.395-2.951,3.952-0.422,7.72c2.53,3.768,7.404,10.54,8.221,13.991c0,0-4.848-10.092-9.169-6.982 c-4.321,3.109,3.768,9.169,7.378,11.383c3.61,2.213,6.139,16.02,6.139,16.02L119.133,287.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M116.208,290.192c2.069-5.204,1.81-11.046-0.711-16.047c-4.348-7.905-5.586-9.775-2.899-11.435 c2.688-1.66,4.005,6.324,4.005,6.324c1.296-3.642,1.389-7.605,0.264-11.304c-1.95-5.744-3.241-15.124-0.685-16.152 c2.556-1.028,0.632,11.699,2.898,16.02c1.1-3.068,1.8-6.265,2.081-9.512c0.237-4.637-0.316-12.015,1.687-13.939 c2.002-1.923,3.32-0.659,1.449,9.617c-1.119,6.086-1.709,12.257-1.765,18.444c0,0,4.242-13.464,7.193-13.912 c2.951-0.448,3.004,3.926,0.501,7.72c-2.503,3.794-7.272,10.54-7.905,14.123c0,0,4.69-10.171,9.064-7.141 c4.374,3.03-3.663,9.248-7.246,11.488c-3.583,2.24-5.955,16.125-5.955,16.125L116.208,290.192z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "132.861,284.395 103.034,284.395 105.458,305.738 130.463,305.738  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M171.458,300.931v4.139h0.668v0.668h-30.937c-1.512,0-2.737-1.225-2.737-2.737 c0-1.512,1.225-2.737,2.737-2.737l0,0h30.937v0.668H171.458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M171.458,300.931v4.139h0.668v0.668h-15.622 c-1.512,0-2.737-1.225-2.737-2.737c0-1.512,1.225-2.737,2.737-2.737l0,0h15.622v0.668H171.458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M171.458,300.931v4.139h-14.954c-1.15,0.022-2.1-0.892-2.123-2.042 c0-0.009,0-0.018,0-0.027c-0.007-1.136,0.907-2.062,2.043-2.07c0.009,0,0.018,0,0.027,0H171.458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M174.783,295.457v4.139h0.668v0.668h-30.937c-1.512,0-2.737-1.225-2.737-2.737 c0-1.512,1.225-2.737,2.737-2.737h30.937v0.668H174.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6",
      enableBackground: "new"
    },
    d: "M174.783,295.457v4.139h0.668v0.668h-15.622 c-1.512,0-2.737-1.225-2.737-2.737c0-1.512,1.226-2.737,2.737-2.737h15.622v0.668H174.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M174.783,295.457v4.139h-14.954c-1.14-0.007-2.062-0.93-2.07-2.069 c-0.007-1.136,0.907-2.062,2.043-2.07c0.009,0,0.018,0,0.027,0H174.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M170.604,289.983v4.139h0.668v0.668h-30.937c-1.512,0-2.737-1.225-2.737-2.737 c0-1.512,1.225-2.737,2.737-2.737h30.937v0.668H170.604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6",
      enableBackground: "new"
    },
    d: "M170.604,289.983v4.139h0.668v0.668h-15.555 c-1.512,0-2.737-1.225-2.737-2.737c0-1.512,1.226-2.737,2.737-2.737l0,0h15.622v0.668H170.604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M170.604,289.983v4.139h-14.888c-1.15,0.03-2.106-0.879-2.136-2.029 c0-0.009,0-0.018-0.001-0.027c-0.016-1.135,0.892-2.069,2.028-2.084c0.036,0,0.072,0,0.109,0.001H170.604z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.609,
    y: 313.656,
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeMiterlimit: 10
    },
    width: 117.402,
    height: 31.804
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M121.356,329.559c0,1.882-1.526,3.408-3.408,3.408c-1.882,0-3.408-1.526-3.408-3.408 c0-1.882,1.526-3.408,3.408-3.408C119.83,326.15,121.356,327.676,121.356,329.559z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Background_simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M180.649,102.318c-22.969,3.032-45.118,9.487-64.762,19.613 c-23.153,11.934-46.809,30.526-39.822,54.845c12.899,44.895,74.78,45.713,62.425,75.899c-13.995,34.193-4.61,74.301,58.189,85.455 c119.277,21.185,263.466-102.77,222.969-170.882C394.436,124.844,302.609,86.218,180.649,102.318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M180.649,102.318c-22.969,3.032-45.118,9.487-64.762,19.613 c-23.153,11.934-46.809,30.526-39.822,54.845c12.899,44.895,74.78,45.713,62.425,75.899c-13.995,34.193-4.61,74.301,58.189,85.455 c119.277,21.185,263.466-102.77,222.969-170.882C394.436,124.844,302.609,86.218,180.649,102.318z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M457.297,464.128c0,3.361-92.81,6.086-207.297,6.086s-207.297-2.725-207.297-6.086 c0-3.361,92.81-6.086,207.297-6.086S457.297,460.767,457.297,464.128z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Question_Mark"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M139.042,420.095c-7.224,0-13.529-2.44-18.918-7.319s-8.082-11.701-8.082-20.474 c0-7.782,2.605-14.329,7.816-19.641c5.211-5.309,11.605-7.967,19.184-7.967c7.46,0,13.737,2.658,18.829,7.967 c5.092,5.312,7.638,11.859,7.638,19.641c0,8.647-2.664,15.443-7.993,20.382C152.186,417.622,146.028,420.095,139.042,420.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M55.846,224.176c0-11.429,3.518-23.008,10.553-34.738c7.035-11.729,17.299-21.444,30.793-29.143 c13.494-7.697,29.236-11.549,47.227-11.549c16.723,0,31.485,3.221,44.287,9.654c12.802,6.436,22.691,15.188,29.669,26.256 c6.977,11.07,10.466,23.098,10.466,36.091c0,10.226-1.989,19.191-5.968,26.888c-3.979,7.699-8.707,14.346-14.186,19.94 c-5.478,5.594-15.31,15.008-29.496,28.241c-3.921,3.729-7.064,7.01-9.428,9.835c-2.364,2.827-4.123,5.414-5.276,7.759 c-1.153,2.346-2.047,4.692-2.682,7.038c-0.634,2.346-1.586,6.469-2.854,12.361c-2.191,12.514-9.053,18.767-20.586,18.767 c-5.997,0-11.043-2.045-15.137-6.135c-4.094-4.088-6.141-10.166-6.141-18.226c0-10.105,1.499-18.858,4.498-26.256 c2.999-7.399,6.977-13.895,11.937-19.489c4.959-5.594,11.648-12.241,20.067-19.94c7.381-6.737,12.715-11.82,16.002-15.248 s6.055-7.246,8.304-11.459c2.249-4.211,3.373-8.78,3.373-13.715c0-9.624-3.431-17.745-10.293-24.361 c-6.862-6.614-15.714-9.925-26.555-9.925c-12.686,0-22.028,3.338-28.025,10.015c-5.997,6.677-11.072,16.512-15.223,29.504 c-3.921,13.597-11.36,20.391-22.316,20.391c-6.458,0-11.908-2.373-16.348-7.128C58.066,234.853,55.846,229.71,55.846,224.176z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.042,420.095c-7.224,0-13.529-2.44-18.918-7.319s-8.082-11.701-8.082-20.474c0-7.782,2.605-14.329,7.816-19.641 c5.211-5.309,11.605-7.967,19.184-7.967c7.46,0,13.737,2.658,18.829,7.967c5.092,5.312,7.638,11.859,7.638,19.641 c0,8.647-2.664,15.443-7.993,20.382C152.186,417.622,146.028,420.095,139.042,420.095z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.846,224.176c0-11.429,3.518-23.008,10.553-34.738c7.035-11.729,17.299-21.444,30.793-29.143 c13.494-7.697,29.236-11.549,47.227-11.549c16.723,0,31.485,3.221,44.287,9.654c12.802,6.436,22.691,15.188,29.669,26.256 c6.977,11.07,10.466,23.098,10.466,36.091c0,10.226-1.989,19.191-5.968,26.888c-3.979,7.699-8.707,14.346-14.186,19.94 c-5.478,5.594-15.31,15.008-29.496,28.241c-3.921,3.729-7.064,7.01-9.428,9.835c-2.364,2.827-4.123,5.414-5.276,7.759 c-1.153,2.346-2.047,4.692-2.682,7.038c-0.634,2.346-1.586,6.469-2.854,12.361c-2.191,12.514-9.053,18.767-20.586,18.767 c-5.997,0-11.043-2.045-15.137-6.135c-4.094-4.088-6.141-10.166-6.141-18.226c0-10.105,1.499-18.858,4.498-26.256 c2.999-7.399,6.977-13.895,11.937-19.489c4.959-5.594,11.648-12.241,20.067-19.94c7.381-6.737,12.715-11.82,16.002-15.248 s6.055-7.246,8.304-11.459c2.249-4.211,3.373-8.78,3.373-13.715c0-9.624-3.431-17.745-10.293-24.361 c-6.862-6.614-15.714-9.925-26.555-9.925c-12.686,0-22.028,3.338-28.025,10.015c-5.997,6.677-11.072,16.512-15.223,29.504 c-3.921,13.597-11.36,20.391-22.316,20.391c-6.458,0-11.908-2.373-16.348-7.128C58.066,234.853,55.846,229.71,55.846,224.176z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M139.042,412.817c-7.224,0-13.529-2.44-18.918-7.319s-8.082-11.702-8.082-20.474 c0-7.782,2.605-14.329,7.816-19.641c5.211-5.309,11.605-7.967,19.184-7.967c7.46,0,13.737,2.658,18.829,7.967 c5.092,5.312,7.638,11.858,7.638,19.641c0,8.647-2.664,15.443-7.993,20.382C152.186,410.344,146.028,412.817,139.042,412.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M55.846,216.898c0-11.429,3.518-23.008,10.553-34.738c7.035-11.73,17.299-21.444,30.793-29.143 c13.494-7.697,29.236-11.549,47.227-11.549c16.723,0,31.485,3.221,44.287,9.654c12.802,6.436,22.691,15.188,29.669,26.256 c6.977,11.07,10.466,23.098,10.466,36.091c0,10.226-1.989,19.191-5.968,26.888c-3.979,7.699-8.707,14.346-14.186,19.94 c-5.478,5.594-15.31,15.008-29.496,28.241c-3.921,3.729-7.064,7.01-9.428,9.835c-2.364,2.827-4.123,5.414-5.276,7.76 c-1.153,2.346-2.047,4.692-2.682,7.038c-0.634,2.346-1.586,6.469-2.854,12.361c-2.191,12.514-9.053,18.767-20.586,18.767 c-5.997,0-11.043-2.045-15.137-6.135c-4.094-4.088-6.141-10.166-6.141-18.226c0-10.105,1.499-18.857,4.498-26.256 c2.999-7.399,6.977-13.895,11.937-19.489c4.959-5.594,11.648-12.241,20.067-19.94c7.381-6.737,12.715-11.82,16.002-15.248 c3.287-3.429,6.055-7.246,8.304-11.459c2.249-4.211,3.373-8.78,3.373-13.715c0-9.624-3.431-17.745-10.293-24.361 c-6.862-6.614-15.714-9.925-26.555-9.925c-12.686,0-22.028,3.338-28.025,10.015c-5.997,6.677-11.072,16.512-15.223,29.504 c-3.921,13.597-11.36,20.391-22.316,20.391c-6.458,0-11.908-2.374-16.348-7.128C58.066,227.575,55.846,222.432,55.846,216.898z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M383.052,85.786c-10.874-8.024-26.195-5.714-34.219,5.161 c-6.195,8.395-6.206,19.428-0.896,27.72l-1.977,7.079l7.72-0.837c0.108,0.083,0.204,0.176,0.314,0.257 c10.874,8.024,26.195,5.714,34.219-5.161C396.237,109.131,393.927,93.81,383.052,85.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M383.052,85.786c-10.874-8.024-26.195-5.714-34.219,5.161 c-6.195,8.395-6.206,19.428-0.896,27.72l-1.977,7.079l7.72-0.837c0.108,0.083,0.204,0.176,0.314,0.257 c10.874,8.024,26.195,5.714,34.219-5.161C396.237,109.131,393.927,93.81,383.052,85.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M385.681,84.203c6.576,4.478,10.633,12.429,10.398,20.382"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M395.842,108.229c0.054,1.212-0.145,2.435-0.582,3.567"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M366.935,106.677c0.412-0.7,1.013-1.472,1.801-2.317c0.579-0.618,1.003-1.138,1.275-1.56 c0.272-0.422,0.408-0.901,0.408-1.437c0-0.761-0.259-1.364-0.776-1.807c-0.517-0.443-1.205-0.664-2.064-0.664 c-0.825,0-1.556,0.201-2.196,0.603c-0.64,0.401-1.179,0.963-1.617,1.683l-3.182-2.193c0.737-1.318,1.731-2.338,2.984-3.059 c1.253-0.721,2.739-1.081,4.457-1.081c2.016,0,3.633,0.505,4.851,1.514c1.218,1.009,1.827,2.41,1.827,4.202 c0,0.845-0.118,1.586-0.355,2.224c-0.237,0.638-0.526,1.179-0.868,1.621c-0.341,0.443-0.784,0.953-1.327,1.53 c-0.648,0.679-1.122,1.251-1.42,1.714c-0.298,0.463-0.448,1.025-0.448,1.684h-3.97 C366.318,108.263,366.523,107.378,366.935,106.677z M366.515,116.041c-0.482-0.488-0.724-1.083-0.724-1.784 c0-0.7,0.237-1.286,0.71-1.756c0.473-0.47,1.079-0.705,1.814-0.705c0.737,0,1.341,0.236,1.814,0.705 c0.473,0.47,0.71,1.056,0.71,1.756c0,0.701-0.24,1.296-0.723,1.784c-0.482,0.489-1.082,0.732-1.801,0.732 C367.597,116.774,366.996,116.53,366.515,116.041z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M153.013,81.545c-7.146,11.471-3.641,26.563,7.83,33.709c8.855,5.517,19.855,4.663,27.705-1.281 l7.212,1.415l-1.44-7.631c0.074-0.114,0.159-0.217,0.232-0.333c7.146-11.471,3.641-26.563-7.83-33.709 C175.251,66.569,160.159,70.075,153.013,81.545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M153.013,81.545c-7.146,11.471-3.641,26.563,7.83,33.709 c8.855,5.517,19.855,4.663,27.705-1.281l7.212,1.415l-1.44-7.631c0.074-0.114,0.159-0.217,0.232-0.333 c7.146-11.471,3.641-26.563-7.83-33.709C175.251,66.569,160.159,70.075,153.013,81.545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M151.229,79.048c3.948-6.908,11.557-11.576,19.503-11.965"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M174.383,67.034c1.204-0.149,2.439-0.046,3.602,0.3"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M173.072,95.348c0.412-0.7,1.013-1.472,1.801-2.317c0.579-0.618,1.003-1.138,1.275-1.56 c0.273-0.422,0.408-0.901,0.408-1.437c0-0.761-0.259-1.364-0.776-1.807s-1.205-0.664-2.064-0.664 c-0.825,0-1.557,0.201-2.196,0.603c-0.64,0.401-1.179,0.963-1.617,1.683l-3.182-2.193c0.736-1.318,1.731-2.338,2.984-3.059 c1.253-0.721,2.739-1.081,4.456-1.081c2.016,0,3.633,0.505,4.851,1.514c1.218,1.009,1.827,2.409,1.827,4.202 c0,0.845-0.118,1.586-0.355,2.224c-0.237,0.638-0.526,1.18-0.868,1.621c-0.341,0.443-0.784,0.953-1.327,1.53 c-0.648,0.68-1.122,1.251-1.42,1.714c-0.298,0.463-0.448,1.025-0.448,1.684h-3.97C172.455,96.934,172.66,96.049,173.072,95.348z  M172.652,104.712c-0.482-0.488-0.724-1.083-0.724-1.784c0-0.7,0.236-1.286,0.71-1.756c0.473-0.47,1.079-0.705,1.814-0.705 c0.737,0,1.341,0.236,1.814,0.705c0.473,0.47,0.71,1.056,0.71,1.756c0,0.701-0.24,1.296-0.723,1.784 c-0.482,0.489-1.082,0.732-1.801,0.732C173.734,105.444,173.134,105.2,172.652,104.712z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M401.135,423.737c-0.018-0.557-1.891-55.838-10.883-64.582 c-8.746-8.502-18.784-0.316-19.206,0.036l-0.902-1.08c0.114-0.096,11.442-9.343,21.088,0.036 c9.396,9.137,11.234,63.248,11.308,65.547L401.135,423.737z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M401.907,434.601c-0.065-0.661-6.145-66.366,17.85-93.904l1.061,0.923 c-23.598,27.082-17.573,92.189-17.51,92.843L401.907,434.601z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M401.02,427.651l-1.405-0.094c0.049-0.745,4.696-74.698-12.905-90.886l0.952-1.036 C405.757,352.279,401.221,424.581,401.02,427.651z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M403.311,427.61l-1.408-0.011c0.017-2.037,0.581-49.952,14.191-57.751 c3.026-1.736,5.988-2.024,8.806-0.859c8.23,3.404,12.308,18.051,12.478,18.673l-1.358,0.371 c-0.04-0.146-4.067-14.604-11.66-17.743c-2.393-0.988-4.939-0.727-7.567,0.779C403.879,378.469,403.315,427.119,403.311,427.61 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M398.01,427.644l-1.404-0.079c0.021-0.378,2.053-37.864-8.064-51.072 c-2.451-3.199-5.112-4.725-7.923-4.528c-6.629,0.463-12.187,10.163-12.242,10.261l-1.226-0.693 c0.241-0.426,5.984-10.455,13.368-10.972c3.303-0.235,6.383,1.476,9.141,5.077C400.094,389.259,398.1,426.084,398.01,427.644z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M400.229,432.743c-0.275-3.637-6.613-89.23,4.538-104.313l1.131,0.835 c-10.843,14.666-4.333,102.485-4.266,103.37L400.229,432.743z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M429.953,373.715c0,0-7.117,2.63-4.701,8.289c6.808,15.945,23.034,17.644,23.034,17.644 s7.614-12.053,1.373-21.415C441.054,365.326,430.133,369.548,429.953,373.715z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M398.85,366.579c0,0,7.124-0.298,7.529,5.841c0.405,6.139-15.433,23.125-15.433,23.125 s-11.302-4.086-8.875-19.407C384.499,360.818,397.08,362.803,398.85,366.579z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M402.304,330.8c0,0-2.992-0.368-4.117-3.061c-3.356-8.032,8.178-16.692,23.6-12.116 c0,0,0.408,13.571-7.89,18.923C405.597,339.899,402.304,330.8,402.304,330.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M375.876,372.886c0,0,2.482-3.404-1.269-3.738c-3.751-0.334-19.99,6.943-15.72,23.6 c0,0,20.886-6.813,21.611-13.786C381.223,371.988,375.876,372.886,375.876,372.886z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M420.407,336.759c0,0,0.938-3.091,4.476-4.383c3.537-1.292,16.679-0.481,16.86,16.713 c0,0-20.216,3.36-22.718-3.19C416.522,339.35,420.407,336.759,420.407,336.759z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M409.494,351.047c0,0,1.359-2.357,3.956-1.095c2.597,1.261,10.255,9.14,2.953,18.652 c0,0-13.569-8.158-12.46-13.884C404.966,349.442,409.494,351.047,409.494,351.047z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M376.252,355.194c0,0,1.959-2.568-0.91-2.886c-2.87-0.318-15.731,3.115-12.735,15.953 c0,0,15.668-1.177,16.339-6.511C379.617,356.417,376.252,355.194,376.252,355.194z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "421.051,461.951 382.756,461.951 378.624,422.325 425.182,422.325  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.185,
    y: 416.897,
    style: {
      fill: "#263238"
    },
    width: 59.437,
    height: 10.858
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M389.547,389.887c-1.174-8.351,3.052-17.647,9.304-23.307"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M409.494,351.517c3.239,3.218,5.492,7.415,6.386,11.893"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M429.953,373.715c6.461,2.869,12.542,8.94,15.636,15.296"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M420.407,336.759c3.346-0.959,6.368,0.066,9.621,1.306c3.253,1.241,6.084,3.56,7.941,6.504"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M392.051,339.656c0,0,4.743,0.566,5.018-2.339c0.275-2.905-15.68-14.21-28.772-4.864 c0,0,4.03,12.965,13.62,15.325C391.506,350.138,392.051,339.656,392.051,339.656z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M391.905,339.893c-4.989-6.704-17.233-8.883-21.402-7.372"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M376.395,355.426c-4.07,1.512-8.417,4.123-10.677,7.831"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M361.119,386.425c3.182-6.102,8.531-11.046,14.864-13.739"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M402.932,330.476c2.54-5.422,7.417-9.7,13.125-11.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3
    },
    points: "379.19,427.754 379.932,434.868 423.874,434.868 424.617,427.746  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_00000130629670595825099640000009958295690175335082_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "251.363,424.445 255.261,453.048 264.583,453.519 267.601,425.945  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M272.52,466.327h-20.85c0,0-0.455-0.876,0.065-3.207c0.079-0.363,0.183-0.762,0.317-1.198 c0.007-0.022,0.012-0.043,0.019-0.065c0.195-0.645,0.419-1.439,0.657-2.295c0.955-3.491,2.078-8.052,2.078-8.052 s3.469-7.427,7.527-5.572c3.561,1.626,2.716,6.281,2.716,6.281s0.349,2.733,3.048,5.144c1.669,1.489,3.329,2.642,4.128,4.494 c0.149,0.346,0.267,0.714,0.351,1.114c0.01,0.048,0.02,0.099,0.027,0.149C272.77,464.013,272.76,465.059,272.52,466.327z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M251.734,463.12c-0.52,2.331-0.065,3.207-0.065,3.207h20.85 c0.241-1.268,0.25-2.314,0.084-3.207H251.734z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M264.21,453.389c-1.173-0.914-2.711-0.795-3.766,0.234c-0.284,0.277-0.719-0.158-0.435-0.435 c1.316-1.284,3.196-1.356,4.636-0.234C264.957,453.197,264.519,453.63,264.21,453.389L264.21,453.389z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M264.799,455.336c-1.173-0.914-2.711-0.795-3.766,0.234c-0.284,0.277-0.719-0.158-0.435-0.435 c1.316-1.284,3.196-1.356,4.637-0.234C265.546,455.144,265.108,455.577,264.799,455.336L264.799,455.336z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M265.39,457.127c-1.173-0.914-2.711-0.795-3.766,0.234c-0.283,0.277-0.719-0.158-0.435-0.435 c1.316-1.284,3.196-1.356,4.636-0.234C266.137,456.935,265.699,457.367,265.39,457.127L265.39,457.127z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "212.229,422.655 208.33,451.258 199.009,451.728 195.99,424.155  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M191.072,464.537h20.85c0,0,0.455-0.876-0.065-3.207c-0.079-0.363-0.183-0.763-0.317-1.198 c-0.007-0.022-0.012-0.044-0.019-0.065c-0.195-0.645-0.419-1.439-0.657-2.295c-0.955-3.491-2.079-8.051-2.079-8.051 s-3.469-7.427-7.527-5.572c-3.561,1.626-2.716,6.281-2.716,6.281s-0.349,2.733-3.048,5.143 c-1.669,1.489-3.329,2.642-4.128,4.494c-0.149,0.346-0.267,0.714-0.351,1.114c-0.009,0.048-0.02,0.099-0.027,0.149 C190.822,462.223,190.831,463.269,191.072,464.537z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M211.857,461.33c0.52,2.331,0.065,3.207,0.065,3.207h-20.85 c-0.241-1.268-0.25-2.314-0.084-3.207H211.857z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M199.381,451.599c1.173-0.914,2.711-0.795,3.766,0.234c0.284,0.277,0.719-0.158,0.435-0.435 c-1.316-1.284-3.196-1.356-4.636-0.234C198.634,451.407,199.072,451.839,199.381,451.599L199.381,451.599z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M198.793,453.546c1.173-0.914,2.711-0.795,3.766,0.234c0.284,0.277,0.719-0.158,0.435-0.435 c-1.317-1.284-3.196-1.356-4.637-0.234C198.046,453.354,198.484,453.786,198.793,453.546L198.793,453.546z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M198.202,455.336c1.173-0.914,2.711-0.795,3.766,0.234c0.283,0.277,0.719-0.158,0.435-0.435 c-1.317-1.284-3.196-1.356-4.636-0.234C197.454,455.144,197.893,455.577,198.202,455.336L198.202,455.336z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M271.781,236.678l-43.361,2.584l-26.527-4.581c0,0-1.801,30.294-4.067,102.276 c-0.494,15.697-4.643,109.01-4.643,109.01l23.318,2.376c0,0,11.582-96.781,13.352-105.233c1.065-5.084,5.04-43.251,8.199-61.496 c1.531,15.216,2.794,51.939,3.951,61.818c0,0,5.788,79.423,6.608,101.953l21.735-1.079c2.682-30.931,3.592-143.598,3.592-143.598 l-0.004-0.002C275.44,277.11,271.781,236.678,271.781,236.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M271.781,236.678l-43.361,2.584l-26.527-4.581c0,0-1.801,30.294-4.067,102.276 c-0.494,15.697-4.643,109.01-4.643,109.01l23.318,2.376c0,0,11.582-96.781,13.352-105.233c1.065-5.084,5.04-43.251,8.199-61.496 c1.531,15.216,2.794,51.939,3.951,61.818c0,0,5.788,79.423,6.608,101.953l21.735-1.079c2.682-30.931,3.592-143.598,3.592-143.598 l-0.004-0.002C275.44,277.11,271.781,236.678,271.781,236.678z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M219.245,134.738c4.028-0.25,14.378-2.369,29.256-0.785c7.744,0.825,14.068,0.644,22.013,4.292 l3.928,95.361c0.059,7.88-1.206,8.983-1.206,8.983s0.227,4.475,0.244,4.613c-26.148,10.105-56.263,9.446-72.918-0.933 c0.393,0.065,0-3.232,0-3.232s-2.511-2.545-1.651-10.643c2.868-27.021,9.154-70.575,13.614-94.876 C212.643,136.918,218.634,134.776,219.245,134.738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M219.245,134.738c4.028-0.25,14.378-2.369,29.256-0.785c7.744,0.825,14.068,0.644,22.013,4.292 l3.928,95.361c0.059,7.88-1.206,8.983-1.206,8.983s0.227,4.475,0.244,4.613c-26.148,10.105-56.263,9.446-72.918-0.933 c0.393,0.065,0-3.232,0-3.232s-2.511-2.545-1.651-10.643c2.868-27.021,9.154-70.575,13.614-94.876 C212.643,136.918,218.634,134.776,219.245,134.738z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M267.655,143.464c-1.032,0-5.23,9.738-7.912,21.547c-2.682,11.809-9.587,34.033-9.587,34.033 l-41.198,6.499l-2.366,19.64c0,0,54.981,5.036,61.377-1.853c6.395-6.888,4.651-8.214,6.971-20.458 c2.069-10.919,3.167-38.341,2.841-45.62C277.318,146.867,269.079,143.492,267.655,143.464z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB373"
    },
    d: "M190.48,205.543c0,0-5.286,7.996-1.762,10.029c3.524,2.033,16.733,5.557,16.733,5.557v-14.973 L190.48,205.543z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M270.165,138.089c-1.032,0-6.743,10.598-9.425,22.407c-2.682,11.809-8.252,39.953-8.252,39.953 l-47.037,5.708v16.926c0,0,56.733,3.936,63.128-2.952c6.395-6.888,6.551-10.389,8.871-22.633 c2.069-10.919,3.167-38.341,2.841-45.62C279.828,141.491,271.589,138.116,270.165,138.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M270.165,138.089c-1.032,0-6.743,10.598-9.425,22.407c-2.682,11.809-8.252,39.953-8.252,39.953 l-47.037,5.708v16.926c0,0,56.733,3.936,63.128-2.952c6.395-6.888,6.551-10.389,8.871-22.633 c2.069-10.919,3.167-38.341,2.841-45.62C279.828,141.491,271.589,138.116,270.165,138.089z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M260.956,151.243c1.581-5.56,6.737-9.822,12.506-10.293c0.478-0.039,0.482-0.789,0-0.75 c-6.105,0.498-11.552,4.944-13.229,10.843C260.1,151.509,260.824,151.708,260.956,151.243L260.956,151.243z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB373"
    },
    d: "M222.426,131.913c0,0,0.749,2.288,0.21,3.027c-0.539,0.739-1.198,0.911-1.198,0.911 s1.153,1.714,0.696,2.8c0,0,1.73,1.943,0.697,3.257c-1.033,1.314-2.171,0.571-2.531,0c-0.359-0.571-1.917,3.464-3.893,2.589 c-1.976-0.875-0.06-3.218,0.539-4.075l-1.917,0.286c0,0-2.815,6.285-4.911,6.571c-2.096,0.286-7.835-0.307-8.35-2.782 c0,0,8.96-16.382,9.582-16.739c0.458-0.262,5.767-1.424,8.54-2.02c1.032-0.222,2.087,0.222,2.62,1.093 c0.884,1.443,1.949,3.529,1.159,4.132C222.426,131.913,222.426,131.913,222.426,131.913"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M201.097,145.86c-0.486,0.695-15.083,45.878-12.655,54.216c2.428,8.339,6.07,11.35,12.14,10.192 c6.07-1.158,9.226-3.011,9.955-10.655c0.728-7.644,5.881-50.06,2.322-52.269C211.15,146.283,201.097,145.86,201.097,145.86z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M198.732,144.086c-0.486,0.695-15.083,45.878-12.655,54.216c2.428,8.339,6.07,11.35,12.14,10.192 c6.07-1.158,9.226-3.011,9.955-10.655c0.728-7.644,6.915-50.155,5.053-50.915C211.362,146.163,198.732,144.086,198.732,144.086z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M198.732,144.086c-0.486,0.695-15.083,45.878-12.655,54.216c2.428,8.339,6.07,11.35,12.14,10.192 c6.07-1.158,9.226-3.011,9.955-10.655c0.728-7.644,6.915-50.155,5.053-50.915C211.362,146.163,198.732,144.086,198.732,144.086z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB373"
    },
    d: "M248.954,137.229c0,0-6.792,5.765-8.564,6.204c-2.383,0.59-9.767-7.375-9.767-7.375 c2.931-3.806,1.51-6.729,0.854-11.109l18.68-18.041c0,0-1.946-0.045-1.957,0c-0.477,1.568-0.589,11.072-0.246,23.093 L248.954,137.229z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M240.963,124.062c-1.568,3.061-5.031,5.428-8.512,6.376c-0.027-0.324-0.153-0.79-0.194-1.109 c-0.062-0.502-0.253-1.246-0.354-1.766c-0.129-0.636-0.288-1.322-0.484-1.965c-0.095-0.251-0.189-0.188-0.284-0.438 l-0.195-0.516l9.7-6.242C241.657,118.815,242.223,121.579,240.963,124.062z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB373"
    },
    d: "M248.817,94.477c-0.3-12.011-12.798-20.021-23.916-14.34 c-11.284,5.767-11.38,23.643-7.885,34.156c3.883,11.68,19.104,15.875,27.383,5.865 C249.903,113.503,249.117,106.488,248.817,94.477L248.817,94.477z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M232.062,101.816c0.191,1.212-0.298,2.29-1.093,2.408c-0.795,0.118-1.594-0.77-1.786-1.983 c-0.191-1.212,0.298-2.29,1.093-2.408C231.071,99.716,231.871,100.604,232.062,101.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M219.734,103.058c0.192,1.212-0.298,2.29-1.092,2.408c-0.795,0.117-1.594-0.77-1.786-1.983 c-0.191-1.212,0.298-2.29,1.093-2.408C218.743,100.958,219.543,101.846,219.734,103.058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C15854"
    },
    d: "M224.349,100.918c0,0-2.888,6.629-3.731,9.276c1.928,1.258,4.724,0.097,4.724,0.097 L224.349,100.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M233.337,95.448c-0.157,0.124-0.376,0.163-0.576,0.082c-2.333-0.935-3.989,0.122-4.16,0.237 c-0.261,0.18-0.621,0.116-0.803-0.142c-0.182-0.259-0.118-0.616,0.141-0.796c0.092-0.064,2.29-1.547,5.253-0.358 c0.296,0.118,0.439,0.452,0.32,0.744C233.473,95.311,233.412,95.389,233.337,95.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M216.086,100.223c-0.097-0.049-0.182-0.127-0.24-0.229c-0.158-0.277-0.065-0.629,0.209-0.787 c2.744-1.584,5.094-0.38,5.207-0.339c0.281,0.146,0.394,0.494,0.251,0.777c-0.143,0.282-0.484,0.394-0.765,0.252 c-0.096-0.054-1.919-0.958-4.121,0.313C216.455,100.309,216.252,100.307,216.086,100.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M245.271,101.739c0,0-1.808-20.342-8.163-21.112s-7.327,5.149-11.49,5.307 c-4.162,0.158-4.102-2.921-4.102-2.921c-2.424,1.731-4.056,6.689-5.747,10.518c0,0,0.861-11.173,5.277-14.581 c8.594-6.633,20.663-5.415,26.126-0.367c5.366,4.959,5.427,15.712,5.427,15.712c-0.541,8.255-1.151,12.889-4.352,18.186 L245.271,101.739z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB373"
    },
    d: "M254.057,101.956c-0.483,3.317-2.461,6.089-4.707,7.683c-3.378,2.399-5.376-1.393-5.639-5.317 c-0.236-3.532,0.111-7.935,4.079-8.775C251.7,94.719,254.609,98.164,254.057,101.956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M250.717,99.003c-0.611-0.655-1.662-0.766-2.488-0.419c-0.825,0.347-1.442,1.073-1.854,1.868 c-0.494,0.954-0.733,2.04-0.686,3.114"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M242.269,85.045c-0.91-2.767-2.737-5.369-5.407-6.532c-1.262-0.55-2.646-0.755-4.017-0.87 c-3.649-0.306-1.231-1.53-4.881-1.234l-3.408,0.85c-2.592,1.032-7.371,3.759-9.577,5.467c-3.501,2.712-7.51,4.768-11.76,6.015 c-0.719,0.211-1.575,0.534-1.704,1.273c-0.131,0.747,0.589,1.351,1.254,1.717c4.269,2.351,9.822,2.157,13.918-0.485 c-0.927,2.719-6.236,4.044-4.278,4.247c5.993,1.304,12.626-0.975,16.552-5.687c-0.005,0.794-0.005,1.615,0.309,2.344 c0.314,0.729,1.032,1.348,1.823,1.287c0.64-0.049,1.17-0.512,1.579-1.007c1.44-1.741,1.965-4.04,2.446-6.247 c2.563,2.706,6.395,12.85,9.343,15.13C249.515,94.568,243.179,87.812,242.269,85.045z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M227.525,114.355c1.26-0.714,2.847-0.805,4.171-0.205c0.184,0.083,0.403,0.053,0.513-0.135 c0.094-0.161,0.051-0.429-0.134-0.513c-1.575-0.714-3.419-0.65-4.928,0.205C226.727,113.945,227.104,114.593,227.525,114.355 L227.525,114.355z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M242.339,75.72c-0.286-1.247-0.789-2.459-1.463-3.546c-0.31-0.5-1.019-0.739-1.539-0.404 c-0.501,0.323-0.736,1.004-0.404,1.539c0.298,0.48,0.558,0.981,0.779,1.501c-0.038-0.09-0.076-0.179-0.113-0.269 c0.241,0.575,0.432,1.168,0.571,1.776c0.132,0.574,0.823,0.967,1.384,0.786C242.154,76.91,242.481,76.335,242.339,75.72 L242.339,75.72z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M243.483,78.306c0.001-0.116,0.004-0.232,0.011-0.348c0.004-0.065-0.011-0.31,0.031-0.346 c-0.021,0.018-0.039,0.245-0.008,0.07c0.009-0.051,0.017-0.102,0.026-0.152c0.021-0.114,0.046-0.227,0.073-0.34 c0.055-0.225,0.122-0.448,0.202-0.665c0.018-0.048,0.036-0.097,0.055-0.145c0.064-0.163,0.059-0.059-0.009,0.019 c0.065-0.074,0.105-0.227,0.15-0.314c0.099-0.195,0.209-0.386,0.328-0.57c0.063-0.098,0.128-0.193,0.197-0.287 c0.018-0.025,0.126-0.168,0.028-0.041c-0.106,0.138,0.034-0.039,0.057-0.067c0.141-0.168,0.29-0.329,0.447-0.481 c0.083-0.081,0.169-0.159,0.257-0.234c0.049-0.042,0.1-0.082,0.149-0.124c0.114-0.098-0.22,0.165-0.013,0.011 c0.244-0.181,0.433-0.369,0.517-0.672c0.074-0.269,0.041-0.628-0.113-0.867c-0.301-0.466-1.034-0.779-1.539-0.404 c-1.894,1.405-3.074,3.582-3.094,5.958c-0.005,0.589,0.521,1.152,1.125,1.125C242.972,79.404,243.477,78.937,243.483,78.306 L243.483,78.306z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M331.189,158.466c0,0,6.171,0.544,10.27,7.616c4.098,7.072,8.117,12.858,8.117,12.858 l-13.257,8.84L331.189,158.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M331.189,158.466c0,0,6.171,0.544,10.27,7.616c4.098,7.072,8.117,12.858,8.117,12.858 l-13.257,8.84L331.189,158.466z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M338.894,219.506c-1.478-0.989-3.366-1.064-5.144-1.082c-13.305-0.134-26.623,1.099-39.677,3.673 l-2.291,1.129c-1.808-1.051-4.225-0.342-5.745,1.093c-1.521,1.435-2.35,3.436-3.133,5.375 c-6.766,16.763-13.207,33.703-17.782,51.192c-1.059,4.048-1.968,8.562,0.023,12.242c2.323,4.294,7.661,5.806,12.468,6.661 c15.703,2.792,31.741,2.965,47.691,2.997c3.876,0.008,8.021-0.071,11.215-2.267c4.473-3.075,5.533-9.13,6.055-14.533 c1.904-19.741,1.725-39.686-0.606-59.381C341.653,223.958,341.108,220.989,338.894,219.506z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B97964"
    },
    points: "323.837,454.087 334.87,455.167 343.024,427.233 326.24,425.406  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M336.468,450.295h-3.939c-0.891,0-1.716,0.451-2.242,1.17c-2.272,3.102-3.979,1.93-6.449-0.987 c-1.571-0.183-1.994,1.62-2.122,2.104l-2.945,10.711c-0.256,0.895,0.262,1.827,1.156,2.083c0.159,0.045,0.324,0.067,0.49,0.065 c4.784,0,7.047,0,13,0h18.208c4.964,0,5.992-5.002,3.948-5.465c-9.194-2.032-15.705-4.737-18.547-7.412 C336.5,452.096,337.041,451.746,336.468,450.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M345.016,453.341c0.415-0.298,0.663-0.775,0.669-1.286c0.035-0.274-0.09-0.544-0.321-0.694 c-1.235-0.874-6.16,1.427-6.712,1.697c-0.061,0.022-0.11,0.07-0.132,0.132c-0.041,0.114,0.018,0.239,0.132,0.28 c1.21,0.286,2.447,0.446,3.691,0.476C343.274,454.034,344.211,453.822,345.016,453.341z M345.054,451.733 c0.1,0.062,0.152,0.18,0.129,0.296c-0.021,0.369-0.199,0.711-0.489,0.939c-1.119,0.836-3.819,0.476-5.272,0.206 C341.467,452.274,344.373,451.258,345.054,451.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M338.818,453.521c1.479-0.617,4.578-3.048,4.411-4.333c-0.026-0.27-0.219-0.592-0.887-0.681 c-2.7-0.309-3.858,4.539-3.858,4.745c-0.027,0.083-0.001,0.174,0.064,0.231c0.05,0.015,0.104,0.015,0.154,0L338.818,453.521z  M342.251,448.905c0.501,0.051,0.501,0.231,0.501,0.296c0.142,0.784-2.109,2.803-3.716,3.652 c0.334-1.132,1.325-3.961,3.035-3.961L342.251,448.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M339.203,453.335c-1.357,0.185-2.615,0.996-3.345,2.155"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M341.651,455.178c-1.357,0.185-2.615,0.996-3.345,2.155"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M344.697,456.727c-1.357,0.185-2.616,0.996-3.345,2.155"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3
    },
    points: "338.714,441.997 337.715,445.422 324.73,443.428 324.965,440.62  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B97964"
    },
    points: "285.604,454.972 296.637,456.053 304.792,428.119 288.007,426.292  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M298.235,451.181h-3.939c-0.891,0-1.716,0.451-2.243,1.17c-2.272,3.102-3.979,1.93-6.45-0.987 c-1.571-0.183-1.993,1.62-2.122,2.104l-2.945,10.712c-0.256,0.894,0.262,1.827,1.156,2.083c0.159,0.046,0.324,0.067,0.489,0.065 c4.784,0,7.047,0,13,0h18.208c4.964,0,5.992-5.002,3.948-5.465c-9.194-2.032-15.704-4.737-18.546-7.412 C298.267,452.982,298.808,452.631,298.235,451.181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M306.783,454.227c0.414-0.298,0.663-0.775,0.669-1.286c0.035-0.274-0.09-0.544-0.322-0.694 c-1.234-0.874-6.159,1.427-6.712,1.697c-0.061,0.022-0.11,0.07-0.132,0.132c-0.041,0.114,0.018,0.239,0.132,0.28 c1.21,0.287,2.447,0.446,3.691,0.476C305.042,454.92,305.979,454.708,306.783,454.227z M306.822,452.619 c0.1,0.062,0.152,0.18,0.129,0.296c-0.021,0.368-0.199,0.71-0.489,0.939c-1.119,0.836-3.819,0.476-5.272,0.206 C303.234,453.159,306.14,452.143,306.822,452.619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M300.585,454.407c1.479-0.617,4.578-3.048,4.411-4.333c-0.026-0.27-0.219-0.591-0.887-0.681 c-2.7-0.309-3.858,4.539-3.858,4.745c-0.027,0.083-0.001,0.174,0.064,0.231c0.05,0.015,0.104,0.015,0.154,0L300.585,454.407z  M304.018,449.79c0.501,0.052,0.501,0.232,0.501,0.296c0.141,0.784-2.109,2.803-3.716,3.652 c0.334-1.132,1.325-3.961,3.035-3.961L304.018,449.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M300.97,454.221c-1.357,0.185-2.615,0.996-3.345,2.155"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M303.418,456.063c-1.357,0.185-2.616,0.996-3.345,2.155"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M306.464,457.613c-1.357,0.185-2.615,0.996-3.345,2.155"
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      opacity: 0.3
    },
    points: "286.497,444.314 286.732,441.505 300.482,442.882 299.482,446.308  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M344.852,242.052c0,0-8.102,8.554-23.981,8.702 c-15.879,0.147-33.693-9.103-33.693-9.103l1.994-3.414l45.726,4.982l8.751-4.982L344.852,242.052z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M346.242,246.959c0,0,9.65,39.531,14.008,74.705c1.328,10.72,1.581,25.057-0.765,35.611 l-17.626,87.624l-22.179-2.222c3.486-37.79,8.343-84.399,9.734-104.23l-25.495-79.344L346.242,246.959z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M317.593,301.752c-0.073,0.367,10.985-44.828,10.985-44.828 s2.97,36.889-8.142,54.495L317.593,301.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M285.248,349.487c0.209-2.233,0.417-6.739,0.619-12.672c-0.03-0.003-0.064-0.005-0.094-0.008 c-0.307-7.77-3.726-43.546-4.322-66.576c-0.06-14.712,2.334-24.992,5.417-30.28c0.159-0.271,0.305-0.519,0.438-0.739 c0.516-0.854,0.835-1.329,0.835-1.329c0.731,0.083,1.456,0.154,2.177,0.214c0.27,0.023,0.538,0.044,0.804,0.064 c27.011,1.995,46.824-8.658,46.824-8.658c3.214,5.652,4.773,4.48,8.297,17.456c-2.347,3.383-9.551,23.239-23.045,27.675 l-1.57,18.374c-0.603,11.343-1.824,22.552-2.787,32.627l-0.941,11.02c-0.05,0.721-0.098,1.436-0.141,2.137 c-0.382,6.313-15.753,109.266-15.753,109.266l-20.555-0.3C281.45,447.758,282.422,379.718,285.248,349.487z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "343.006,439.199 341.86,444.899 319.68,442.677  320.256,436.487  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "302.005,448.058 302.872,442.242 281.45,441.985  281.45,447.758  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M282.739,187.865l-6.897-23.519c4.363-6.512,25.952-11.516,25.952-11.516l14.223,0.778 c0,0,5.467,1.22,10.147,2.746c6.248,2.038,9.627,3.677,11.117,7.144c0,0,2.607,7.682,1.04,23.511 c-0.431,4.353-1.416,27.325-0.201,34.8l8.836,17.288c-25.989,20.239-59.26,0.009-59.26,0.009 c1.168-3.574,3.736-11.489,4.264-14.982c-0.381-4.456-1.632-7.382-3.519-15.184C288.076,207.434,283.372,189.329,282.739,187.865 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M282.739,187.865l-6.897-23.519c4.363-6.512,25.952-11.516,25.952-11.516 l14.223,0.778c0,0,5.467,1.22,10.147,2.746c6.248,2.038,9.627,3.677,11.117,7.144c0,0,2.607,7.682,1.04,23.511 c-0.431,4.353-1.416,27.325-0.201,34.8l8.836,17.288c-25.989,20.239-59.26,0.009-59.26,0.009 c1.168-3.574,3.736-11.489,4.264-14.982c-0.381-4.456-1.632-7.382-3.519-15.184C288.076,207.434,283.372,189.329,282.739,187.865 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "285.439,196.292 286.706,196.292 290.525,185.015  288.839,210.556 285.319,197.187  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M312.728,228.429c-6.436-4.419-14.444-6.496-22.217-5.763l-3.805,9.991 c10.642,9.595,23.656,10.882,37.977,10.435C326.7,235.682,319.164,232.848,312.728,228.429z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M342.672,221.996c-1.051-1.965-3.193-3.528-5.395-3.187c-1.64,0.254-2.95,1.465-4.082,2.678 c-4.498,4.816-7.962,10.592-10.092,16.828l0.839,4.779c1.481-0.608,2.962-1.216,4.442-1.824 c4.198-1.724,8.526-3.535,11.663-6.814C343.184,231.176,344.811,225.998,342.672,221.996z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M331.03,239.123c0,3.321-2.692,6.014-6.014,6.014c-3.321,0-6.014-2.692-6.014-6.014 c0-3.321,2.692-6.014,6.014-6.014C328.338,233.109,331.03,235.802,331.03,239.123z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M327.626,262.745c-0.498-7.14-0.996-14.28-1.494-21.421l-2.796,1.816 c-8.757,12.794-12.594,28.867-10.561,44.237c3.734,0.645,7.536,0.889,11.322,0.729c-1.067-2.254-2.134-4.508-3.201-6.762 c3.301-1.289,5.481-4.588,6.349-8.023C328.113,269.886,327.873,266.28,327.626,262.745z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M339.777,270.282c1.597-2.178,1.894-5.052,1.724-7.747c-0.54-8.569-5.499-16.741-12.85-21.178 l-1.195-0.939c4.27,12.881,3.439,26.821,2.562,40.363c2.87-0.581,5.74-1.162,8.61-1.743c-0.885-1.776-1.789-3.816-1.089-5.672 C337.989,272.172,339.022,271.312,339.777,270.282z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M317.219,111.693c0,0,2.358,26.135,3.661,33.643c4.102,4.908,20.327,1.363,13.976-15.915 c-3.35-9.115-3.638-20.641-9.967-25.336C315.998,97.491,317.219,111.693,317.219,111.693z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97964"
    },
    d: "M315.027,154.894c-1.488-1.486-2.159-3.03-1.878-5.193c0.196-1.663,0.733-3.391,1.372-5.073 l-2.22-2.413l-11.546-10.837c0.551,7.496,1.888,19.517-3.831,23.804l18.102,14.63V154.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M313.088,150.202c-3.129-1.707-6.604-4.739-6.332-8.358c0.125-1.524,0.4-2.973,0.73-3.908 l6.549,8.05C313.572,147.333,313.389,148.179,313.088,150.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97964"
    },
    d: "M297.728,119.434c1.463,11.406,1.842,16.251,7.965,22.038 c9.21,8.704,22.766,5.172,24.707-6.257c1.747-10.286-0.939-27.21-12.348-31.613 C306.81,99.266,296.264,108.028,297.728,119.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M322.745,145.222c-9.03-4.113-12.57-2.996-11.908-0.718c0.302,1.039,4.373,1.684,4.373,1.684 s0.914,0.086,1.346,0.117c0.389,0.028,0.638,0.245,0.619,0.264C316.864,146.894,322.441,145.622,322.745,145.222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M328.384,140.492c0,0-0.435-0.557-1.169-0.298c-0.735,0.259-2.464,1.627-2.475,3.957 c0,0,0.928-0.587,1.967-1.566C327.368,141.963,328.384,140.492,328.384,140.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M313.248,123.455c0.009,1.074,0.626,1.985,1.377,2.037c0.751,0.051,1.353-0.778,1.344-1.851 s-0.626-1.985-1.377-2.037C313.841,121.552,313.239,122.381,313.248,123.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M324.891,122.454c-0.051,1.039,0.512,1.959,1.257,2.055c0.745,0.095,1.39-0.67,1.441-1.709 c0.051-1.039-0.512-1.959-1.257-2.055C325.587,120.65,324.942,121.415,324.891,122.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M311.534,121.691c0.146,0.009,0.292-0.04,0.401-0.149c1.687-1.713,3.698-1.232,3.721-1.226 c0.298,0.072,0.588-0.108,0.642-0.411c0.052-0.303-0.149-0.609-0.451-0.685c-0.105-0.026-2.629-0.632-4.722,1.494 c-0.208,0.212-0.196,0.57,0.027,0.799C311.259,121.621,311.397,121.682,311.534,121.691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M329.553,116.138c0.132-0.044,0.245-0.134,0.309-0.264c0.131-0.267,0.003-0.596-0.285-0.735 c-2.888-1.394-5.139-0.185-5.234-0.132c-0.267,0.148-0.346,0.479-0.176,0.742c0.169,0.262,0.523,0.355,0.79,0.209 c0.088-0.049,1.848-0.96,4.145,0.148C329.251,116.177,329.413,116.184,329.553,116.138z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M306.741,100.787c-3.93,0.646-6.403,1.21-9.499,3.147 c-3.096,1.937-6.407,6.654-8.213,10.25c-2.573,5.126-2.762,11.425-2.879,17.413c-0.077,3.938-0.065,8.223,1.938,11.337 c1.345,2.092,3.435,3.342,5.578,3.917c2.144,0.575,4.364,0.538,6.559,0.474c1.812-0.053,4.017-0.436,4.688-2.464 c1.056-3.189-2.926-6.149-2.392-9.522"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97964"
    },
    d: "M294.604,128.887c1.437,2.298,3.687,3.692,5.719,4.124c3.056,0.65,4.444-4.277,3.3-7.275 c-1.03-2.698-4.072-4.398-6.999-3.696C293.741,122.733,292.961,126.259,294.604,128.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A24E3F"
    },
    d: "M320.879,121.732c0,0,1.946,4.219,4.062,6.816c0.37,0.454,0.176,1.143-0.365,1.365 c-1.394,0.572-3.065,0.161-3.065,0.161L320.879,121.732z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M314.364,121.567l2.655-0.497C317.019,121.07,315.491,122.96,314.364,121.567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M326.06,120.744l2.679-0.338C328.739,120.406,327.102,122.202,326.06,120.744z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M294.638,113.184c-1.552,2.243,1.538,8.758,1.538,8.758s5.489-1.632,5.789,6.636 c2.025,0.335,4.297-7.385,3.966-15.146C305.525,109.048,297.379,109.225,294.638,113.184z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M298.812,124.889c-0.97-0.372-1.977,0.269-2.296,1.07c-0.386,0.97,0.148,3.223,3.12,3.93"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M326.995,106.819c-2.421-5.033-12.284-9.709-23.625-4.849 c-10.246,4.375-14.6,19.411-7.195,19.973c7.405,0.562,19.333-8.404,19.333-8.404L326.995,106.819z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97964"
    },
    d: "M341.851,196.336l11.536,0.266l2.574,5.866l-5.932,7.513c0,0-1.418-0.085-0.952-2.065 c0.361-1.535,1.193-2.733,1.193-2.733l-7.879,2.37c-1.494,0.449-3.01-0.632-3.072-2.19l-0.362-9.07L341.851,196.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97964"
    },
    d: "M274.355,175.271c0,0-0.424,5.673,1.906,12.827c2.33,7.155,8.106,26.24,14.956,31.496 c6.85,5.255,24.212-2.6,34.63-7.149c10.315-4.504,15.816-6.661,16.004-6.692l-2.893-9.461l-37.846,5.516l-16.236-34.563 C284.877,167.245,273.219,167.148,274.355,175.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M335.163,195.577c0,0,2.699,7.043,6.087,8.21c3.388,1.166,12.001,1.497,12.755-6.61 L335.163,195.577z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M275.842,164.347c-7.104,6.867,0.841,33.439,0.841,33.439l22.683-5.976 c0,0-5.39-20.018-10.81-25.064C283.964,162.493,279.742,160.456,275.842,164.347z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M275.842,164.347c-7.104,6.867,0.841,33.439,0.841,33.439l22.683-5.976 c0,0-5.39-20.018-10.81-25.064C283.964,162.493,279.742,160.456,275.842,164.347z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M319.627,133.882c0.88-0.026,1.761,0.004,2.637,0.098c0.431,0.046,0.86,0.109,1.286,0.186 c0.253,0.046,0.769,0.049,0.922,0.296c0.255,0.409,0.904,0.033,0.648-0.378c-0.215-0.345-0.544-0.476-0.927-0.555 c-0.507-0.105-1.019-0.186-1.532-0.252c-1.006-0.129-2.02-0.175-3.033-0.144C319.145,133.146,319.143,133.896,319.627,133.882 L319.627,133.882z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M313.089,150.803c0.001,0.018-1.193,0.388-0.907,1.676c0.286,1.288,0.736,1.451,0.736,1.451 s-1.315,1.411,0.171,2.964c0,0,0.831,0.859,2.446,0.634c0,0,3.475,5.826,6.297,6.051l0.859,0.163l8.092,16.955l-8.572-30.496 L313.089,150.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97964"
    },
    d: "M330.527,155.993c0,0-0.2-8.273-0.839-9.641c-0.638-1.368-1.414-1.779-1.414-3.284 c0-1.505,0.274-2.691-0.593-2.509c-0.867,0.182-1.688,1.779-1.916,2.965c-0.228,1.186,0.274,4.333,0.274,4.333 s-6.522-3.923-9.122-4.516c-2.167-0.494-4.745-0.862-5.57,0.138c-0.351,0.425-0.16,1.09,0.321,1.361 c0.388,0.219,1.033,0.477,2.102,0.736c3.602,0.871,4.789,1.551,4.789,1.551s-3.466-0.183-4.379,0.456 c-0.912,0.639-0.867,1.089-0.639,1.822c0.228,0.733,0.821,1.234,0.821,1.234s-1.14-0.365-1.551,1.095 c-0.411,1.46,0.73,1.961,0.73,1.961s-1.095,1.049-0.456,2.372c0.639,1.323,2.509,0.867,2.509,0.867s4.88,5.929,6.75,6.066 c1.87,0.137,4.287-1.186,4.105-1.186c-0.182,0,4.333-5.245,4.333-5.245L330.527,155.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97964"
    },
    d: "M322.954,162.62c0,0,9.135,27.671,12.596,33.672c3.461,6.002,9.288,7.947,14.927,5.415 c1.348-0.605,2.421-2.111,3.264-3.922c2.547-5.473,0.753-9.04-2.102-14.359c-2.328-4.338-2.328-4.338-2.328-4.338l-4.734,3.103 l-14.344-26.729L322.954,162.62z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhat);
export default __webpack_public_path__ + "static/media/What.af603d2739645556fbaf5d2ef1783eb1.svg";
export { ForwardRef as ReactComponent };